import { render, staticRenderFns } from "./SecForm.vue?vue&type=template&id=bf9effe6&scoped=true"
import script from "./SecForm.vue?vue&type=script&lang=js"
export * from "./SecForm.vue?vue&type=script&lang=js"
import style0 from "./SecForm.vue?vue&type=style&index=0&id=bf9effe6&prod&lang=css&scoped=true"
import style1 from "./SecForm.vue?vue&type=style&index=1&id=bf9effe6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf9effe6",
  null
  
)

export default component.exports